module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-ru-RU.d50b1915.jpg";